import React from 'react';
import SEO from '../../components/common/SEO';
import Breadcrumbs from '../../components/common/Breadcrumbs';

const Tokushoho = () => {
    const sectionStyle = "border-b border-gray-200 grid grid-cols-1 md:grid-cols-3";
    const dtStyle = "font-bold text-gray-800 bg-gray-50 p-4 md:col-span-1";
    const ddStyle = "p-4 leading-relaxed text-sm sm:text-base md:col-span-2";

    return (
        <>
            <SEO 
                title="特定商取引法に基づく表記｜請求書一括発行 Billwave"
                description="Stripe請求書一括発行サービス「Billwave」を運営する株式会社シグナルの特定商取引法に基づく表記です。販売事業者、運営責任者、所在地、連絡先、販売価格、支払方法、キャンセル・解約規定等を掲載しています。"
                path="/tokushoho"
            />
            <div className="max-w-4xl mx-auto px-4 py-8">
                <Breadcrumbs items={[{ label: '特定商取引法に基づく表記' }]} />

                <div className="bg-white p-8 rounded-lg shadow border border-gray-100 text-gray-700">
                    <h1 className="text-3xl font-extrabold text-gray-900 text-center mb-10">特定商取引法に基づく表記</h1>
                    
                    <div className="border border-gray-200 rounded-lg overflow-hidden">
                        <dl>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>販売業者</dt>
                                <dd className={ddStyle}>株式会社シグナル</dd>
                            </div>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>運営責任者</dt>
                                <dd className={ddStyle}>森 州宏</dd>
                            </div>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>所在地</dt>
                                <dd className={ddStyle}>〒101-0046<br/>東京都千代田区神田多町2-1-7 神田Y5ビル9F</dd>
                            </div>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>電話番号</dt>
                                <dd className={ddStyle}>
                                    03-6426-5805<br/>
                                    受付時間：平日10:00～17:00（土日祝日・年末年始を除く）<br/><br/>
                                    ※お問い合わせはお問い合わせフォームをご利用ください。
                                </dd>
                            </div>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>メールアドレス</dt>
                                <dd className={ddStyle}>
                                    invoice@s-nal.jp<br/><br/>
                                    ※本メールアドレスは請求に関するお問い合わせ専用です。
                                </dd>
                            </div>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>ホームページ</dt>
                                <dd className={ddStyle}>
                                    会社：https://s-nal.jp<br/>
                                    サービス：https://billwave.jp
                                </dd>
                            </div>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>販売価格</dt>
                                <dd className={ddStyle}>各プラン紹介ページに表示された料金（税込または税別表示）をご確認ください。</dd>
                            </div>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>商品代金以外の必要料金</dt>
                                <dd className={ddStyle}>
                                    消費税<br/>
                                    インターネット接続に必要な通信料金（お客様負担）
                                </dd>
                            </div>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>お支払い方法</dt>
                                <dd className={ddStyle}>
                                    クレジットカード<br/>
                                </dd>
                            </div>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>お支払い時期</dt>
                                <dd className={ddStyle}>
                                    契約期間満了日の翌日に決済を行います。<br/>
                                    実際の引き落とし日は、ご利用の決済事業者の定める日となります。
                                </dd>
                            </div>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>サービス提供時期</dt>
                                <dd className={ddStyle}>
                                    アカウント登録および決済完了後、直ちにご利用いただけます。<br/><br/>
                                    システムメンテナンス等により提供開始が遅れる場合があります。
                                </dd>
                            </div>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>契約期間・更新</dt>
                                <dd className={ddStyle}>
                                    契約期間は1か月単位です。<br/>
                                    解約のお申し出がない限り、自動更新されます。
                                </dd>
                            </div>
                            <div className={sectionStyle}>
                                <dt className={dtStyle}>解約について</dt>
                                <dd className={ddStyle}>
                                    契約者は管理画面からいつでも解約手続きを行うことができます。<br/>
                                    解約後は契約期間満了日をもってサービスの提供を終了します。
                                </dd>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-3">
                                <dt className={dtStyle}>返品・キャンセル</dt>
                                <dd className={ddStyle}>
                                    本サービスはデジタルコンテンツ・クラウドサービスの性質上、契約成立後のお客様都合による返品・返金はできません。<br/><br/>
                                    ただし、法令に基づく場合または当社利用規約に別途定める場合を除きます。
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Tokushoho;
